import DirectApi from '../../../directApi';

export const fetchData = (startDate, endDate, personId) => {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	const body = {
		method: 'POST',
		headers,
		credentials: 'include',
		body: JSON.stringify({
			startYear: startDate.year(),
			startMonth: startDate.month() + 1,
			startDay: startDate.date(),
			endYear: endDate.year(),
			endMonth: endDate.month() + 1,
			endDay: endDate.date(),
			personIds: [personId],
		}),
	};
	return fetch(DirectApi.graphqlServerEndpoint('scheduling/utilization_v2'), body)
		.then(response => response.json())
		.then(data => {
			const distributionMap = new Map();
			Object.keys(data[personId].distribution).forEach(id => {
				distributionMap.set(id, data[personId].distribution[id]);
			});

			let minutesAllocated = data[personId].minutesAllocated;
			let minutesAllocatedHard = data[personId].minutesAllocatedHard;
			let minutesAllocatedSoft = data[personId].minutesAllocatedSoft;
			let minutesAllocatedSoftWin = data[personId].minutesAllocatedSoftWin;

			return {
				distributionMap,
				minutesAllocated,
				minutesAllocatedHard,
				minutesAllocatedSoft,
				minutesAllocatedSoftWin,
			};
		});
};
